module.exports = __webpack_public_path__ + "static/media/dark_yellow-theme.a11aec50.png";